module.exports = __webpack_public_path__ + "static/media/10.e3ac9922.jpg";